import { getBlob, getBytes, ref } from 'firebase/storage'

import { getFirebaseStorage } from '@/lib/firebase/app'
import { memoised } from '@/lib/templates/memoised'
import type { TemplateFiles } from '@/lib/templates/template-files'
import type { DesignScope } from '@/repositories/design'

/** The files of one design folder in the brand's workspace storage, each path read once. */
export function designFiles(scope: DesignScope, folder: string): TemplateFiles {
  const prefix = `workspaces/${scope.workspaceId}/brands/${scope.brandId}/workspace/${folder}/`
  const objectRef = (path: string) => ref(getFirebaseStorage(), `${prefix}${path}`)
  return {
    readText: memoised(async (path) => new TextDecoder().decode(await getBytes(objectRef(path)))),
    readObjectUrl: memoised(async (path) => URL.createObjectURL(await getBlob(objectRef(path)))),
  }
}
